module.exports = __webpack_public_path__ + "img/6554690.abc88bb0.png";